import { MousedOverTextHelper } from "../../state/uiAtoms";
import { IsInPortrait, TogglePanelFor } from "../../state/selectors";
import { TopBarControl } from "../StyledControl";
import { text } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { useMetrics } from "../../hooks/useMetrics";

function ShareControl() {
	const setTextHelper = useSetRecoilState(MousedOverTextHelper);
	const isInPortrait = useRecoilValue(IsInPortrait);
	const togglePanelFor = useSetRecoilState(TogglePanelFor);
	const { track } = useMetrics();
	// the panel opens regardless of publish state: PDF export works on
	// unpublished stories; the link/QR sections gate themselves inside
	const handleClick = () => {
		togglePanelFor("share");
		track('share_clicked');
	};

	const mouseOver = () => {
		setTextHelper(text.controls.share);
	};

	const mouseLeave = () => {
		setTextHelper(undefined);
	};

	return (
		<TopBarControl
			$isInPortrait={isInPortrait}
			id="action-control-qr"
			data-testid="share-control"
			onClick={handleClick}
			onMouseOver={mouseOver}
			onMouseLeave={mouseLeave}
			aria-label={text.controls.share}
		>
			{text.controls.share}
		</TopBarControl>
	);
}

export default ShareControl;
